import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';

@Component({
  selector: 'app-file-upload-form-field',
  templateUrl: './file-upload-form-field.component.html',
  styleUrls: ['./file-upload-form-field.component.scss']
})
export class FileUploadFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  
  constructor() { }

  ngOnInit(): void {
  }

}
